module.exports = __webpack_public_path__ + "img/variableairvolumeunit.a92d946b.svg";